export default {
      id: "Clock-icon-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "sprite.svg#Clock-icon",
      toString: function () {
        return this.url;
      }
    }